import React from 'react';

const Button = props => {
  let spinner;
  if (props.loading) {
    spinner = (<i className="mr-2 fas fa-circle-notch fa-spin"></i>)
  }
  return (
    <button
      type="button"
      style={props.style}
      className={`${props.className} ${props.loading ? "btn-secondary":""}`}
      onClick={props.loading ? null : props.onClick}
    >
      {spinner}
      {props.children}
    </button>
  )
};

export default Button;
